import React, { useState, useRef } from 'react';
import { Modal } from 'react-bootstrap';
import "./Flip.css";

const Flip = () => {
    const [showModal, setShowModal] = useState(false);
    const [flipResult, setFlipResult] = useState('');
    const [isFlipping, setIsFlipping] = useState(false); // état ajouté

    const videoSuccessRef = useRef(null);
    const videoFailRef = useRef(null);

    const handleShowFlip = () => {
        if (isFlipping) return; // bloque si déjà en cours

        setIsFlipping(true);

        const randomNumber = Math.floor(Math.random() * 100) + 1;
        const result = randomNumber % 2 === 0 ? 'side-a' : 'side-b';
        setFlipResult(result);
        setShowModal(true);

        setTimeout(() => {
            let videoEl = result === 'side-a' ? videoSuccessRef.current : videoFailRef.current;
            if (videoEl) {
                videoEl.currentTime = 0;
                videoEl.play();
            }
        }, 0);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setFlipResult('');
        setIsFlipping(false); // réactivation une fois terminé
    };

    return (
        <div
            className={`flip ${isFlipping ? "disabled" : ""}`}
            onClick={handleShowFlip}
            style={{ pointerEvents: isFlipping ? "none" : "auto" }}
        >
            <div className="col-12">
                <div
                    id="flip_coin"
                    className="d-flex flex-row align-items-center justify-content-center flip-inner mt-4"
                >
                    {/* Préchargement invisible */}
                    <video ref={videoSuccessRef} preload="auto" style={{ display: "none" }}>
                        <source src="/assets/Success.mp4" type="video/mp4"/>
                    </video>
                    <video ref={videoFailRef} preload="auto" style={{ display: "none" }}>
                        <source src="/assets/Fail.mp4" type="video/mp4"/>
                    </video>

                    {/* Modal vidéo */}
                    <Modal show={showModal} onHide={handleCloseModal} centered>
                        <Modal.Body className="video-container">
                            {flipResult === 'side-a' &&
                                <video
                                    ref={videoSuccessRef}
                                    autoPlay
                                    muted
                                    onEnded={handleCloseModal}
                                    className="video-responsive"
                                >
                                    <source src="/assets/Success.mp4" type="video/mp4"/>
                                </video>}
                            {flipResult === 'side-b' &&
                                <video
                                    ref={videoFailRef}
                                    autoPlay
                                    muted
                                    onEnded={handleCloseModal}
                                    className="video-responsive"
                                >
                                    <source src="/assets/Fail.mp4" type="video/mp4"/>
                                </video>}
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default Flip;
